import {finder} from "@medv/finder";


export function generateElementSelector(el) {
    return finder(el, {
        seedMinLength: 5,
        optimizedMinLength: 3,
    });
}
